import { Component, Input, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxSpinnerService } from 'ngx-spinner';
import { TabsService } from '../../tabs.service';
import { ProgramBuilderMainService } from 'src/app/modules/creation-center/components/program-builder-main/program-builder-main.service';
import { OrganizationService } from 'src/app/modules/obsolete/components/organization/organization.service';
import { UsersService } from '../users/users.service';

@Component({
  selector: 'app-program-access-by-roles',
  templateUrl: './program-access-by-roles.component.html',
  styleUrls: ['./program-access-by-roles.component.scss']
})
export class ProgramAccessByRolesComponent implements OnInit {
  @Input() organisationId: string = '';
  programs: any = [];
  categories: any = [];
  organisationData: any = {};
  orgRoles: any = [];
  programAccess: any = [];
  showPrograms: any = false;

  constructor(
    private spinner: NgxSpinnerService,
    private snackbar: MatSnackBar,
    private programBuilderMainService: ProgramBuilderMainService,
    private tabsService: TabsService,
    private organizationService: OrganizationService,
    private usersService: UsersService
  ) {
    this.tabsService.organisationId$.subscribe(async organisationId => {
      this.organisationId = organisationId;
      if (this.organisationId) {
        this.organisationData = await this.organizationService.getOrganizationData(this.organisationId);
        // console.log('this.organisationHierarchy', this.organisationData)
        this.getRoles();
      }
    });
  }

  ngOnInit() {
    this.getCategories()
  }

  showProgramsData(val: any, index: any, category: any) {
    // console.log('index ', index, category )
    // console.log('val', val)
    if (val === 'show') {
      category.subCategories[index].showPrograms = true
    } else if (val === 'hide') {
      category.subCategories[index].showPrograms = false
    }

  }

  getRoles() {
    this.usersService.getRoles(this.organisationId).subscribe((roles: any) => {
      if (roles.length > 0) {
        this.orgRoles = roles;
        // console.log('this.orgRoles', this.orgRoles)
      }
    });
  }

  getCategories() {
    this.programBuilderMainService.getCategories().subscribe((data: any) => {
      this.categories = data;
      // console.log('Categories:', this.categories);
      this.getProgramsForSubcategories();
    });
  }

  getProgramsForSubcategories() {
    this.programBuilderMainService.getPrograms().subscribe((data: any) => {
      this.programs = data;

      this.categories.forEach((category: any) => {
        category.subCategories.forEach((subCategory: any) => {
          subCategory.programs = subCategory.programs || [];
          this.programs.forEach((program: any) => {
            if (program.subCategory.id === subCategory.id) {
              subCategory.programs.push(program);
            }
          });
          if (this.organisationData.allowedPrograms) {
			subCategory.programs = subCategory.programs.filter((program: any) => {
			  return this.organisationData.allowedPrograms.includes(program.id);
			});
		}
          subCategory.showPrograms = false;
        });
      });

      // console.log('Categories with Programs:', this.categories);
    });
  }

  categoryHasPrograms(category: any): boolean {
    return category.subCategories.some((subCategory: any) => this.subCategoryHasPrograms(subCategory));
  }

  subCategoryHasPrograms(subCategory: any): boolean {
    return subCategory.programs && subCategory.programs.length > 0;
  }

  toggleRoleForProgram(program: any, role: any, boolean: any) {
    if (!this.organisationData.programAccess) {
      this.organisationData.programAccess = [];
    }

    const dataIndex = this.organisationData.programAccess.findIndex((data: any) => data.roleId === role.id && data.programId === program.id);

    if (dataIndex !== -1) {
      this.organisationData.programAccess[dataIndex].allowed = boolean;
    } else {
      this.organisationData.programAccess.push({
        roleId: role.id,
        programId: program.id,
        allowed: boolean
      });
    }
  }

  async saveOrganisationData() {
    try {
      this.organisationData.updatedAt = new Date();
      await this.organizationService.saveOrganisationdata(this.organisationData, this.organisationId);
      this.snackbar.open("Organisation updated successfully", "OK", {
        duration: 3000
      });
    } catch (err) {
      console.error('Failed to save organisation data:', err);
      this.snackbar.open("Failed to save. Please try again.", "OK", {
        duration: 3000
      });
    }
  }



	getToggleState(program: any, role: any) {
		// console.log('program', program, role)
		// console.log('this.organisationData.programAccess', this.organisationData.programAccess)

		if (this.organisationData.programAccess) {
			const entry = this.organisationData.programAccess.find((item: any) => item.roleId == role.id && item.programId == program.id);
			return entry ? entry.allowed : true;
		}

		return true;
	}
}
